import type { App } from '../App';
import type { AppRemoteConfig } from '../platform/Platform';
import { DEFAULT_RAW_REMOTE_CONFIG } from './defaultRemoteConfig';
import { rawAppRemoteToAppRemote } from './rawAppRemoteToAppRemote';

let platformRemoteConfig: AppRemoteConfig | null = null;

export async function loadRemoteConfig(app: App): Promise<void> {
  await app.platform.platformRemoteConfig.init();
  platformRemoteConfig = app.platform.platformRemoteConfig.getRemoteConfig();
}

export function getPlatformRemoteConfig(): AppRemoteConfig {
  if (!platformRemoteConfig) {
    return rawAppRemoteToAppRemote(DEFAULT_RAW_REMOTE_CONFIG);
  }
  return platformRemoteConfig;
}
